var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6 1a1 1 0 0 1 1 1v3h10a2 2 0 0 1 2 2v10h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H7a2 2 0 0 1-2-2V7H2a1 1 0 0 1 0-2h3V2a1 1 0 0 1 1-1zm11 6H7v10h10z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }